import { AssignLicenseInDto, AssignLicenseOutDto } from '../../../types/license.dto'

export const ASSIGN_LICENSE = 'ASSIGN_LICENSE'
export const ASSIGN_LICENSE_SUCCESS = 'ASSIGN_LICENSE_SUCCESS'
export const ASSIGN_LICENSE_ERROR = 'ASSIGN_LICENSE_ERROR'
export const RESET_ASSIGN_LICENSE = 'RESET_ASSIGN_LICENSE'

export interface AssignLicense {
  type: typeof ASSIGN_LICENSE
  payload: AssignLicenseOutDto
}

export interface AssignLicenseSuccess {
  type: typeof ASSIGN_LICENSE_SUCCESS
  payload: AssignLicenseInDto
}

export interface AssignLicenseError {
  type: typeof ASSIGN_LICENSE_ERROR
  payload: string | boolean
}

export interface ResetAssignLicense {
  type: typeof RESET_ASSIGN_LICENSE
  payload: null
}

export interface State {
  data: AssignLicenseInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | AssignLicense
  | AssignLicenseSuccess
  | AssignLicenseError
  | ResetAssignLicense
